var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtmlaf7415B4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 126,
    viewBox: "0 0 89 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.7977 24.8765L80.7955 115.583L44.8247 125.673L8.953 115.597L0.958984 24.8765H88.7977Z",
    fill: "#E44D26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8783 117.961L73.9445 109.807L80.7827 32.2944H44.8783V117.961Z",
    fill: "#F16529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.322 54.5474H44.8783V43.4209H17.3043L17.5674 46.4059L20.2703 77.0676H44.8783V65.9411H30.3271L29.322 54.5474Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8004 82.6311H20.7616L22.3021 100.101L44.8277 106.428L44.8783 106.414V94.8379L44.8301 94.8508L32.5834 91.5049L31.8004 82.6311Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13123 0.222656H14.7195V5.80906H19.8316V0.222656H25.4202V17.1397H19.8319V11.4749H14.7198V17.1397H9.13157V0.222656H9.13123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7686 5.83275H27.8497V0.222656H43.28V5.83275H38.3579V17.1397H32.7697V5.83275H32.7693H32.7686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7288 0.222656H51.5556L55.14 6.16685L58.7209 0.222656H64.5502V17.1397H58.9846V8.75468L55.14 14.7696H55.0436L51.1965 8.75468V17.1397H45.7288V0.222656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3312 0.222656H72.9211V11.5481H80.7798V17.1397H67.3308V0.222656H67.3312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8404 77.0676H58.3814L57.1047 91.4979L44.8401 94.8473V106.423L67.3836 100.101L67.5488 98.2214L70.1333 68.9289L70.4015 65.9412H44.8404V77.0676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8403 54.5202V54.5474H71.402L71.6224 52.0466L72.1237 46.4059L72.3864 43.4209H44.8403V54.5205V54.5202Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.1452,
    height: 125.768,
    fill: "white",
    transform: "translate(0.805664 0.222656)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlaf7415B4);
export default __webpack_public_path__ + "static/media/html.af7415b4.af7415b44c85ea8d24c1314a4ff5a19d.svg";
export { ForwardRef as ReactComponent };